import React, { useState, useEffect } from 'react';
import type { ViewType } from '@/types/components';
import PasswordPrompt from './auth/PasswordPrompt';
import styles from './HomePage.module.css';

interface HomePageProps {
  onNavigate?: (view: ViewType) => void;
}

const HomePage: React.FC<HomePageProps> = ({ onNavigate }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleTileNavigate = (view: ViewType) => {
    if (!onNavigate) {
      return;
    }
    onNavigate(view);
  };

  useEffect(() => {
    const auth = sessionStorage.getItem('bam_authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  if (!isAuthenticated) {
    return <PasswordPrompt onSuccess={() => setIsAuthenticated(true)} />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          src="/BAM-logo-embedded.svg" 
          alt="Book Award Mastery" 
          className={styles.logo}
        />
        
        <div className={styles.tiles}>
          <a
            href="http://localhost:8081/#bam-database"
            className={styles.tile}
            onClick={() => handleTileNavigate('bam-database')}
          >
            <h2 className={styles.tileTitle}>BAM Database</h2>
          </a>

          <a
            href="http://localhost:8081/#perfect-match"
            className={styles.tile}
            onClick={() => handleTileNavigate('perfect-match')}
          >
            <h2 className={styles.tileTitle}>BAM Services</h2>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
